<template>

<div>
  <b-container>
    <b-form-row>
      <b-col>
        <label class="d-block">Identificador
          <b-form-input type="text" v-model="client.codeId"/>
        </label>
      </b-col>
      <b-col>
        <label class="d-block">Denominación
          <b-form-input type="text" v-model="client.name"/>
        </label>
      </b-col>
      <b-col>
        <label class="d-block">Estado
          <b-form-select v-model="client.status" :options="statusOptions"/>
        </label>
      </b-col>
    </b-form-row>
  </b-container>
</div>

</template>

<script>

export default {
  name: 'ClientForm',
  model: {prop: 'client'},
  props: {
    client: {type: Object, required: true}
  },
  data() {
    return {
      statusOptions: [
        {text: 'Activo', value: 'ACTIVATED'},
        {text: 'Baja', value: 'DEACTIVATED'}
      ]
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/client/ClientForm.vue